import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from './message/message.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../header/header.module';
import { LossControlComponent } from './loss-control/loss-control.component';
import { SortableDirective } from '../_directives/sortable.directive';
import { TypeaheadComponent } from './typeahead/typeahead.component';

@NgModule({
  declarations: [
    DashboardComponent,
    MessageComponent,
    LossControlComponent,
    SortableDirective
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    FormsModule,
    HeaderModule
  ],
  exports: [SortableDirective]
})
export class HomeModule { }